import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=9645e2dc&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=9645e2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9645e2dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9645e2dc')) {
      api.createRecord('9645e2dc', component.options)
    } else {
      api.reload('9645e2dc', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=9645e2dc&scoped=true&", function () {
      api.rerender('9645e2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2v43YzHtgGuYy/JS/comp/DateRangeExt.vue"
export default component.exports